var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pendo-dropdown-button-split--guide-create",attrs:{"id":_vm.drawerId}},[_c('pendo-multiselect',{attrs:{"min-menu-width":100,"options":_vm.formattedOptions},on:{"select":_vm.select},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('pendo-split-button-trigger',{staticClass:"create-guide",attrs:{"theme":"app","type":"primary","label":_vm.buttonOption.label},on:{"click":() => {
                        _vm.select(_vm.buttonOption);
                    }}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }